import { Injectable } from '@angular/core';
import { StringHelpers } from '@mode/shared/util-js';
import { getHrefFromResource } from '../get-href-from-resource';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class LibraryDefinitionModel extends ModeModelBase {
  override _name = 'definition';
  initials: any;
  name: string;
  editLink: any;
  override idAttribute = 'token';
  override hasOne = [
    { name: 'query', idAttribute: 'token' },
    { name: 'queryRun', as: 'lastRun', idAttribute: 'token' },
    { name: 'account', as: 'creator', idAttribute: 'username' },
  ];
  override belongsTo = 'account';
  override parentIdAttribute = 'username';
  override attributes = [
    { name: 'name', default: '' },
    { name: 'source', default: '' },
    { name: 'description', default: '' },
    { name: 'dataSourceId', default: null },
    { name: 'token', default: null },
    { name: 'created_at', default: null },
    { name: 'updated_at', default: null },
  ];
  override initialize(resource) {
    this.initials = StringHelpers.initialize(this.name || 'Definition');

    this.editLink = getHrefFromResource(resource, 'web_edit');
  }
  updateInitials() {
    this.initials = StringHelpers.initialize(this.name || 'Definition');
  }
}

@Injectable({ providedIn: 'root' })
export class LibraryDefinitionModelAccessor extends ModelAccessorBase<LibraryDefinitionModel> {
  override name = 'definition';
  override idAttribute = 'token';
  override parentModel = 'account';
  override parentIdAttribute = 'username';
  override createAttributes = ['account'];

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.definition');
  }

  createModel(resource, opts?) {
    const model = new LibraryDefinitionModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
